/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DELETE_TWITCH: 'Peruuta Twitch-integraatio',
    ERROR: 'Virhe',
    FETCH_DATA: 'Hae tiedot'
  },
  HEADER: {
    DATE: 'Päivämäärä',
    MESSAGE: 'Viesti',
    NAME: 'Nimi',
    ORDER_CODE: 'Cod. Enc.',
    ORDER_VALUE: 'Arvo'
  },
  LABEL: {
    ACTIVE_SINCE: 'Aktiivinen vuodesta',
    INTEGRATIONS: 'Integraatiot',
    TWITCH: 'Twitch',
    TWITCH_AUTH: 'Valtuuttaa Twitch',
    TWITCH_AUTHORIZED_INFORMATION:
      'Prozis on valtuutettu tuottamaan Twitch-hälytyksiä striimien aikana.',
    TWITCH_INFORMATION:
      'Prozis pyytää lupaa Twitch-ilmoitusten luomiseen striimien aikana.',
    TWITCH_INTEGRATION: 'Twitch-integraatio'
  },
  SENTENCE: {},
  SUCCESS: {
    DELETE_TWITCH: 'Twitch-integraatio peruutettu',
    SUCCESS: 'Menestys'
  },
  TOOLTIP: {
    ORDER_CODE: 'Tilauskoodi'
  }
};
